import { Injectable } from '@angular/core';

import { PageCategories } from '@digital-platform/rs-analytics/domain';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  public getPageCategories(pathname: string): PageCategories {
    const categories = [
      'about-us',
      'businesses',
      'business-development',
      'communities',
      'customer-support',
      'locations',
      'our-company',
      'pay-bill',
      'procurement',
      'residents',
      'schedule',
      'shop',
      'sitemap',
    ];

    const result: PageCategories = {
      pageType: '',
      primaryCategory: splitPathName(1) || 'home',
      subCategory1: splitPathName(2) || '',
      subCategory2: splitPathName(3) || '',
    };

    if (
      !result.subCategory1 &&
      !categories.includes(result.primaryCategory) &&
      result.primaryCategory !== 'home'
    ) {
      result.primaryCategory = '';
    }

    if (result.primaryCategory === null) {
      result.primaryCategory = 'nocategory';
    }

    if (pathname === '/404') {
      result.pageType = 'error404';
      result.primaryCategory = '404';
    }

    return result;

    function splitPathName(step: number) {
      return pathname.split('/')[step];
    }
  }
}
